import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import {
  connectSortBy,
  connectPagination,
} from "instantsearch.js/es/connectors";
import {
  hits,
  refinementList,
  currentRefinements,
  clearRefinements,
  configure
} from "instantsearch.js/es/widgets";
import axios from "axios";

const collectionClient = algoliasearch(
  "MB13IY345Y",
  "5a50c24f3e92ae83f808068a942a1f3b",
);

const collectionPageEnabled = true;
let collectionFacetFilter = null;
let collectionRulesContextValue = null;
let collectionHandle = null;
let subCollectionHandle = null;

if (collectionPageEnabled) {
  let matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
  let matches2 = window.location.pathname.match(
    /\/collections\/([^/]+)\/([^/]+)/i,
  );
  collectionHandle =
    Boolean(matches) && matches.length === 2 ? matches[1] : null;
  subCollectionHandle =
    Boolean(matches2) && matches2.length === 3 ? matches2[2] : null;
}

// subCollectionHandle.replace('-', '_'); 
// subCollectionHandle.replace('%20', '_');
let filterTag = `"${subCollectionHandle}"`;

const indexName = "shopify_products";

const collectionSearch = instantsearch({
  indexName: "shopify_products",
  searchClient: collectionClient,
  insights: false,
  analytics: false,
  routing: {
    stateMapping: {
      stateToRoute(uiState) {
        const indexUiState = uiState[indexName];
        return {
          q: indexUiState.query,
          type:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Type"],
          flavourGroup:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.FlavourGroup"],
          flavour:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Flavour"],
          brand:
            indexUiState.refinementList && indexUiState.refinementList.vendor,
          size:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Size"],
          strength:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Strength"],
          ratio:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Ratio"],
          wattage:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Wattage"],
          battery:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Battery"],
          resistance:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Resistance"],
          offers:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Offer"],
          page: indexUiState.page,
        };
      },
      routeToState(routeState) {
        return {
          [indexName]: {
            query: routeState.q,
            refinementList: {
              type: routeState.type,
              flavourGroup: routeState.flavourGroup,
              flavour: routeState.flavour,
              brand: routeState.brand,
              size: routeState.size,
              strength: routeState.strength,
              ratio: routeState.ratio,
              wattage: routeState.wattage,
              battery: routeState.battery,
              resistance: routeState.resistance,
              offers: routeState.offers,
            },
            page: routeState.page,
          },
        };
      },
    },
  },
});

const index = collectionClient.initIndex("shopify_products");

document.querySelector("#hits").classList.remove("loading");

let acc = document.querySelectorAll(".refine-trigger");
let macc = document.querySelectorAll(".mobile-refine-trigger");
let panel = document.querySelectorAll(".refine");

acc.forEach((i) => {
  i.addEventListener("click", () => {
    let setClasses = !i.classList.contains("active");
    setClass(acc, "active", "remove");
    setClass(panel, "show", "remove");

    if (setClasses) {
      i.classList.toggle("active");
      let ref = i.nextElementSibling;
      if (ref) {
        ref.classList.toggle("show");
      }
    }
  });
});

const setClass = (els, className, fnName) => {
  for (let i = 0; i < els.length; i++) {
    els[i].classList[fnName](className);
  }
};

const selectors = {
  body: document.querySelector("body"),
  mobileMenuToggle: document.querySelector("#mobile-menu-toggle"),
  menuClose: document.querySelector("#menu-close"),
  menuApply: document.querySelector("#mobile-apply"),
  mobileFilterMenu: document.querySelector(".mobile-filter-menu"),
  mobileFilterBackdrop: document.querySelector(".mobile-filter-backdrop"),
};

if (selectors.mobileMenuToggle !== null) {
  selectors.mobileMenuToggle.addEventListener("click", () => {
    // document.location.href = '#top';
    selectors.body.classList.add("blocked");
    selectors.mobileFilterMenu.classList.toggle("active");
    selectors.mobileFilterBackdrop.classList.toggle("active");
  });
}

if (selectors.mobileMenuToggle !== null) {
  selectors.menuClose.addEventListener("click", () => {
    // document.location.href = '#mobile-sorter';
    selectors.body.classList.remove("blocked");
    selectors.mobileFilterMenu.classList.remove("active");
    selectors.mobileFilterBackdrop.classList.remove("active");
  });
}

if (selectors.menuApply !== null) {
  selectors.menuApply.addEventListener("click", () => {
    selectors.body.classList.remove("blocked");
    selectors.mobileFilterMenu.classList.remove("active");
    selectors.mobileFilterBackdrop.classList.remove("active");
    document.querySelector('#collection-mobile-toolbar').scrollIntoView(true);
  });
}


const determineProductCard = (data) => {
  let productURL = `/products/${data.handle}`;

  let promo_img = document
    .querySelector("#hits")
    .getAttribute("data-promo-source");
  let promo_url = document
    .querySelector("#hits")
    .getAttribute("data-promo-url");
  let promo_span = document
    .querySelector("#hits")
    .getAttribute("data-promo-span");
  let promo_start = document
    .querySelector("#hits")
    .getAttribute("data-string-pos");

  let promo_title = document
    .querySelector("#hits")
    .getAttribute("data-promo-title");
  let promo_desc = document
    .querySelector("#hits")
    .getAttribute("data-promo-text");
  let promo_cta = document
    .querySelector("#hits")
    .getAttribute("data-promo-cta");

  let promo_t_colour = document
    .querySelector("#hits")
    .getAttribute("data-title-colour");
  let promo_colour = document
    .querySelector("#hits")
    .getAttribute("data-text-colour");

  let promo_colour_start = document
    .querySelector("#hits")
    .getAttribute("data-bg-colour-start");
  let promo_colour_end = document
    .querySelector("#hits")
    .getAttribute("data-bg-colour-end");

  const hasMultiBuy = () => {
    let all = data.tags.toString();

    if (isOutOfStockHelper()) {
      return "";
    } else {
      if (
        (all && all.includes("Item_pro_Buy")) ||
        all.includes("Item_pro1_Buy")
      ) {
        return `<div class="card-product__badge card-product__multiOffer multi-buy">Multi Buy</div>`;
      } else {
        return ``;
      }
    }
  };

  const isBundle = () => {
    let all = data.tags.toString();
    if (all.includes("Bundle")) {
      return `<div class="card-product__badge card-product__multiOffer bundle-offer">Bundle Offer</div>`;
    } else {
      return ``;
    }
  };

  const isEarly = () => {
    let all = data.tags.toString();
    if (all.includes("Early Bird")) {
      return `<div class="card-product__badge card-product__multiOffer earlybird">Early Bird22</div>`;
    } else {
      return ``;
    }
  };

  const isBundleWeek = () => {
    let all = data.tags.toString();
    if (all.includes("BundleWeek")) {
      return `<div class="card-product__badge card-product__multiOffer bundle-of-week">Bundle of the Week</div>`;
    } else {
      return ``;
    }
  };

  const isQuitKit = () => {
    let all = data.tags.toString();
    if (all.includes("Quit Kit")) {
      return `<div class="card-product__badge card-product__multiOffer quit-kit">Quit Kit of the Week</div>`;
    } else {
      return ``;
    }
  };

  const isNew = () => {
    let all = data.collections.toString();
    if (all.includes("new")) {
      return `<div class="card-product__badge card-product__newHighlight">New in</div>`;
    } else {
      return ``;
    }
  };

  const isSale = () => {
    let all = data.collections.toString();
    if (all.includes("sale")) {
      return `<div class="card-product__badge card-product__saleHighlight">Sale</div>`;
    } else {
      return ``;
    }
  };

  const hasFlavour = () => {
    // console.log(data);
    if (data.named_tags.Profile) {
      if (typeof data.named_tags.Profile == "string") {
        return data.named_tags.Profile;
      }
    } else {
      return "";
    }
  };

  const isDisposable = () => {
    let all = data.collections.toString();
    if (all.includes("disposable-vape-kits")) {
      return true;
    } else {
      return false;
    }
  };

  const disposableCount = () => {
    let all = data.tags;
    let c = "";
    all.filter((t, i) => {
      if (t.includes("Profile_")) {
        c = t.replace("Profile_", "");
        return t.replace("Profile_", "");
      } else {
        return "";
      }
    });
    return c;
  };

  const isOutOfStockHelper = () => {
    if (data.variants_inventory_count == 0) {
      return true;
    } else {
      return "";
    }
  };

  const isOutOfStock = () => {
    if (data.variants_inventory_count <= 0) {
      return `<div class="card-product__oos">Out Of Stock</div>`;
    } else {
      return "";
    }
  };

  const getMultibuyOffer = () => {
    let tags = data.tags.toString();
    let _items = window?.multibuyOffer?.tags;
    // console.log(_items);

    if (isOutOfStockHelper()) {
      return "";
    } else {
      if (data.collections) {
        let found = false;
        let content;

        for (let i = 0; i < _items.length; i++) {
          if (tags.includes(_items[i].tag)) {
            found = true;
            content = _items[i].return;
            break;
          }
        }

        if (found) {
          return content;
        } else {
          return ``;
        }
      }
    }
  };


  const getRelevantBadge = () => {
    let tags = data.tags.toString();
    let _items = window?.relevantBadges?.tags;


    if (isOutOfStockHelper()) {
      return "";
    } else {
      if (data.collections) {
        let found = false;
        let content;

        for (let i = 0; i < _items.length; i++) {
          if (tags.includes(_items[i].tag)) {
            found = true;
            content = _items[i].return;
            break;
          }
        }

        if (found) {
          return content;
        } else {
          return ``;
        }
      }
    }

  };

  const isOnSale = () => {

    if (!data.compare_at_price) {
      return false;
    } else {
      return true;
    }
  };


  const areAllVariantsDiscounted = () => {
    if (data.compare_at_price != 0 && data.variants_min_price == data.variants_max_price) {
      return true;
    } else {
      return false;
    }
  };

  const determinePrice = () => {


    let originalPrice;
    if (!data.compare_at_price) {
      originalPrice = data.price;
    } else {
      originalPrice = data.compare_at_price;
    }

    if (data.price == 0) {
      return "TBC";
    }

    if (isOnSale()) {
      if(areAllVariantsDiscounted()) {
        return `<span class="pre-sale-price"> Was £${originalPrice}</span> <span class="sale-price">Now £${data.variants_min_price.toFixed(2)}</span>`
      } else {
        return data.variants_count > 1
        ? `From £${data.variants_min_price.toFixed(2)}`
        : `£${data.price.toFixed(2)}`
      }
    } else {
      return data.variants_count > 1 && data.variants_min_price != data.variants_max_price
        ? `From £${data.variants_min_price}`
        : `£${data.price.toFixed(2)}`;
    }
  };

  setClickedObject = (id) => {
    localStorage.setItem("clickedObjectID", id);
  };

  if (data.isPromo == "true") {
    return `
          <div id="promo-card-1" class="card-product promo-card card-carousel-js swiper-slide ${
            promo_span == "true" && "span-two"
          } start-pos-${promo_start}" data-handle="promo-only">
          <a style="background: linear-gradient(99deg,${promo_colour_start}, ${promo_colour_end});" class="card-product__wrapper-link" href="${promo_url}"></a>
            <div class="collection-breaker-inner">
              <h3 style="color: ${promo_t_colour}" class="breaker-title">${promo_title}</h3>
              <p style="color: ${promo_colour}" class="breaker-desc">${promo_desc}</p>
              <a href="${promo_url}"><button class="breaker-cta button button--primary button--primary--alternate">${promo_cta}</button></a>
            </div>
            <div class="card-product__imagewrap">
             <img src="${promo_img}" />
            </div>
          </div>
        `;
  } else {
    return `
          <div id="card-${data.id}" data-objectID="${
      data.objectID
    }" class="card-product card-carousel-js swiper-slide" data-handle="${
      data.handle
    }" onClick="setClickedObject(${data.objectID})">
          <a class="card-product__wrapper-link" href="/products/${
            data.handle
          }" title="${data.title}"></a>
            <div class="card-product__imagewrap">
              <img
                class="card-product__thumb ${
                  isOutOfStockHelper() ? "greyed" : ""
                }"
                srcset="${data.product_image}&amp;width=165 100w,${
      data.product_image
    }&amp;width=165 165w,${data.product_image}&amp;width=360 360w,${
      data.product_image
    }&amp;width=533 533w,${data.product_image} 600w"
                sizes="(min-width: px) -50px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
                src="${data.product_image}"
                alt="${data.title}"
                width="230"
                height="100%"
                loading="${data.__position <= 10 ? 'eager' : 'lazy'}"
                />
            </div>
              ${getRelevantBadge()}
              ${isNew()}
              ${isSale()}
              ${getMultibuyOffer()}
            <div class="card-product__wrapper">
              <h3 class="card-product__heading">${data.title}</h3>
              ${
                isDisposable()
                  ? `<div class="card-product__flavour">${disposableCount()}</div>`
                  : `<div class="card-product__flavour">${hasFlavour()}</div>`
              }
              <div class="card-product__price ${
                isOutOfStockHelper() ? "greyed" : ""
              }">
                ${determinePrice() == '£null' ? `£${data.price.toFixed(2)}` : determinePrice()}
              </div>
            </div>
          </div>
        `;
  }
};

const applyMobileFilters = (d) => {};

const determineShowMore = (d) => {
  // console.log(d);
};

// ensure the collection results are in sync with the collection handle, and returns no duplicate variants
// compare the second 'sub collection' handle and if there is one, use that as a filter by tags within this collection

let uri = filterTag.replaceAll("%20", " ");
let q = uri.replaceAll("-", " ");

// encodeURIComponent(uri).replace(/%20/g, '-');
// uri.replaceAll(' ', '-');
// console.log(uri);

// let currentURL = window.location.pathname;
// const pattern = new URLPattern({pathname: '/collections/:main/:sub'});
// const result = pattern.exec({pathname: currentURL});

// // result.pathname.groups.sub.replace('-', ' ');
// // let q = result.pathname.groups.sub.replaceAll('-', ' ');

function getCookie(cookieName) {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let [key, value] = el.split("=");
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
}

let isPromoCard = document.querySelector("#hits").getAttribute("data-promo");
let promoPos = document
  .querySelector("#hits")
  .getAttribute("data-promo-position");
let pp = document.querySelector("#hits").getAttribute("data-per-page");
let isSpan = document.querySelector("#hits").getAttribute("data-promo-span");

// let refc = document.querySelector('#current-filters .');

const determineHitsPerPage = () => {
  if (isPromoCard == "true") {
    if (isSpan == "true") {
      return parseInt(pp) - 2;
    } else {
      return parseInt(pp) - 1;
    }
  } else {
    return parseInt(pp);
  }
};


// add the refinements

collectionSearch.addWidgets([
  configure({
    filters: subCollectionHandle ? `collections:${collectionHandle} AND tags:${q}` : `collections:${collectionHandle}`,
    facetingAfterDistinct: true,
    maxValuesPerFacet: 1000,
    enablePersonalization: true,
    userToken: getCookie("_ALGOLIA"),
    hitsPerPage: determineHitsPerPage(),
  })
])

collectionSearch.addWidgets([
  refinementList({
    container: "#refine-type",
    attribute: "named_tags.Type",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      root: "group-list",
    },
  }),

  currentRefinements({
    container: "#current-filters",
    transformItems(items) {
      items.map((i) => {
        switch (i.label) {
          case "named_tags.Type":
            i.label = "Type";
            break;
          case "named_tags.FlavourGroup":
            i.label = "Flavour Group";
            break;
          case "named_tags.Flavour":
            i.label = "Flavour";
            break;
          case "vendor":
            i.label = "Brand";
            break;
          case "named_tags.Size":
            i.label = "Size";
            break;
          case "named_tags.Strength":
            i.label = "Strength";
            break;
          case "named_tags.Ratio":
            i.label = "PG/VG Ratio";
            break;
          case "named_tags.Wattage":
            i.label = "Wattage";
            break;
          case "named_tags.Battery":
            i.label = "Battery";
            break;
          case "named_tags.Resistance":
            i.label = "Resistance";
            break;
          case "named_tags.Offer":
            i.label = "Offers";
            break;
          case "price":
            i.label = "Price";
            break;
          default:
            break;
        }
      });
      return items;
    },
  }),

  clearRefinements({
    container: "#clear-filters",
    templates: {
      resetLabel: "Clear All",
    },
  }),

  refinementList({
    container: "#mobile-refine-type",
    attribute: "named_tags.Type",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      root: "group-list",
    },
  }),

  refinementList({
    container: "#refine-flavourGroup",
    attribute: "named_tags.FlavourGroup",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      root: "group-list",
    },
  }),

  refinementList({
    container: "#mobile-refine-flavourGroup",
    attribute: "named_tags.FlavourGroup",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      root: "group-list",
    },
  }),

  clearRefinements({
    container: "#mobile-clear",
    templates: {
      resetLabel: "Clear",
    },
  }),


  refinementList({
    container: "#refine-flavour",
    attribute: "named_tags.Flavour",
    limit: 10,
    showMore: true,
    showMoreLimit: 100,
    transformItems(items) {
      if (items.length > 10) {
        document.querySelector("#refine-flavour").classList.add("opened");
      } else {
        document.querySelector("#refine-flavour").classList.remove("opened");
      }
      return items;
    },
    cssClasses: {
      root: "flavour-list",
    },
  }),


  refinementList({
    container: "#mobile-refine-flavour",
    attribute: "named_tags.Flavour",
    limit: 10,
    showMore: true,
    showMoreLimit: 100,
    cssClasses: {
      root: "flavour-list",
    },
  }),


  refinementList({
    container: "#refine-brand",
    attribute: "vendor",
    limit: 10,
    showMore: true,
    showMoreLimit: 100,
    transformItems(items) {
      if (items.length > 10) {
        document.querySelector("#refine-brand").classList.add("opened");
      } else {
        document.querySelector("#refine-brand").classList.remove("opened");
      }
      return items;
    },
  }),

  refinementList({
    container: "#mobile-refine-brand",
    attribute: "vendor",
    limit: 10,
    showMore: true,
    showMoreLimit: 100,
  }),

 refinementList({
    container: "#refine-size",
    attribute: "named_tags.Size",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),


  refinementList({
    container: "#mobile-refine-size",
    attribute: "named_tags.Size",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#refine-nic",
    attribute: "named_tags.Strength",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#mobile-refine-nic",
    attribute: "named_tags.Strength",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#refine-ratio",
    attribute: "named_tags.Ratio",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#mobile-refine-ratio",
    attribute: "named_tags.Ratio",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#refine-wattage",
    attribute: "named_tags.Wattage",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),


  refinementList({
    container: "#mobile-refine-wattage",
    attribute: "named_tags.Wattage",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),


  refinementList({
    container: "#refine-battery",
    attribute: "named_tags.Battery",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),


  refinementList({
    container: "#mobile-refine-battery",
    attribute: "named_tags.Battery",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),


  refinementList({
    container: "#refine-resistance",
    attribute: "named_tags.Resistance",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),


  refinementList({
    container: "#mobile-refine-resistance",
    attribute: "named_tags.Resistance",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),


  refinementList({
    container: "#refine-offers",
    attribute: "named_tags.Offer",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),


  refinementList({
    container: "#mobile-refine-offers",
    attribute: "named_tags.Offer",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

])

const renderSortBy = (renderOptions, isFirstRender) => {
  const {options, currentRefinement, hasNoResults, refine, widgetParams} =
    renderOptions;

  if (isFirstRender) {
    const select = document.createElement("div");
    // select.setAttribute("size", 10);
    select.setAttribute("class", "select-sortby");

    select.addEventListener("click", (event) => {
      // console.log(event);
      refine(event.target.id);
    });

    widgetParams.container.appendChild(select);
  }

  const select = widgetParams.container.querySelector("div");

  select.disabled = hasNoResults;

  select.innerHTML = `
      ${options
        .map(
          (option) => `
            <span
              class="sort-option"
              id="${option.value}"
              ${option.value === currentRefinement ? "selected" : ""}
            >
              ${option.label}
            </span>
          `,
        )
        .join("")}
    `;
};

// Create the custom widget
const customSortBy = connectSortBy(renderSortBy);

const renderMobileSortBy = (renderOptions, isFirstRender) => {
  const {options, currentRefinement, hasNoResults, refine, widgetParams} =
    renderOptions;

  if (isFirstRender) {
    const select = document.createElement("div");
    // select.setAttribute("size", 10);
    select.setAttribute("class", "select-sortby");

    select.addEventListener("click", (event) => {
      // console.log(event);
      refine(event.target.id);
    });

    widgetParams.container.appendChild(select);
  }

  const select = widgetParams.container.querySelector("div");

  select.disabled = hasNoResults;

  select.innerHTML = `
      ${options
        .map(
          (option) => `
            <span
              class="sort-option"
              id="${option.value}"
              ${option.value === currentRefinement ? "selected" : ""}
            >
              ${option.label}
            </span>
          `,
        )
        .join("")}
    `;
};

// Create the custom widget
const customMobileSortBy = connectSortBy(renderMobileSortBy);

collectionSearch.addWidgets([
  customSortBy({
    container: document.querySelector("#sort-by"),
    items: [
      {label: "Featured", value: "shopify_products"},
      {
        label: "Best Selling",
        value: "shopify_products_recently_ordered_count_desc",
      },
      {label: "Price ascending", value: "shopify_products_price_asc"},
      {label: "Price descending", value: "shopify_products_price_desc"},
      {label: "Title ascending", value: "shopify_products_title_asc"},
      {label: "Title descending", value: "shopify_products_title_desc"},
      {label: "Created ascending", value: "shopify_products_published_at_asc"},
      {
        label: "Created descending",
        value: "shopify_products_published_at_desc",
      },
    ],
  }),
]);

collectionSearch.addWidgets([
  customMobileSortBy({
    container: document.querySelector("#mobile-sort-by"),
    items: [
      {label: "Featured", value: "shopify_products"},
      {
        label: "Best Selling",
        value: "shopify_products_recently_ordered_count_desc",
      },
      {label: "Price ascending", value: "shopify_products_price_asc"},
      {label: "Price descending", value: "shopify_products_price_desc"},
      {label: "Title ascending", value: "shopify_products_title_asc"},
      {label: "Title descending", value: "shopify_products_title_desc"},
      {label: "Created ascending", value: "shopify_products_published_at_asc"},
      {
        label: "Created descending",
        value: "shopify_products_published_at_desc",
      },
    ],
  }),
]);

function middleware({instantSearchInstance}) {
  return {
    onStateChange({uiState}) {
      // console.log('middleware: ', uiState.shopify_products);

      if (uiState.shopify_products.refinementList) {
        if (document.querySelector("#promo-card-1")) {
          document.querySelector("#promo-card-1").style.display = "none";
        }
      } else {
        if (document.querySelector("#promo-card-1")) {
          document.querySelector("#promo-card-1").style.display = "block";
        }
      }

      // Do something with `uiState` whenever the state changes.
    },
    subscribe() {},
    unsubscribe() {},
  };
}

collectionSearch.addWidgets([
  hits({
    container: "#hits",
    transformItems(items) {
      let promoData = {
        title: "Promo Card",
        updated_at: "2023-03-27T14:24:40.000Z",
        isPromo: "true",
        __position: parseInt(promoPos),
      };
      if (isPromoCard == "true") {
        items.splice(parseInt(promoPos) - 1, 0, promoData);
      }
      return items;
    },
    templates: {
      empty: "Loading...",
      item: (data) => {
        return determineProductCard(data);
      },
    },
    cssClasses: {
      root: "hits-results-list",
      list: "results-grid",
    },
  }),
]);


// Create the render function
const renderPagination = (renderOptions, isFirstRender) => {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
    widgetParams,
  } = renderOptions;

  const container = document.querySelector("#pagination");  

  container.innerHTML = `
    <ul class="ais-Pagination-list">
      ${
        !isFirstPage
          ? `
            <li class="ais-Pagination-item ais-Pagination-item--page">
              <a
                href="https://www.vapesuperstore.co.uk${window.location.pathname}"
                data-value="${0}"
                rel="prev"
              >
                <
              </a>
            </li>
            <li class="ais-Pagination-item ais-Pagination-item--page">
              <a
                href="${currentRefinement == 1 ? `https://www.vapesuperstore.co.uk${window.location.pathname}` : createURL(currentRefinement - 1)}"
                data-value="${currentRefinement - 1}"
                rel="prev"
              >
                Previous
              </a>
            </li>
            `
          : ""
      }
      ${pages
        .map((page) => {
          let current = currentRefinement;
          let direction;

          if (page + 1 > current) {
            direction = "next";
          } else {
            direction = "prev";
          }

          return `
        <li class="ais-Pagination-item ais-Pagination-item--page ${
          currentRefinement === page ? " ais-Pagination-item--selected" : ""
        }">
          <a
            href="${page == 0 ? `https://www.vapesuperstore.co.uk${window.location.pathname}` : createURL(page)}"
            data-value="${page}"
            style="font-weight: ${
              currentRefinement === page ? "bold" : "inherit"
            }"
            ${page != current ? `rel="${direction}"` : ""}
          >
            ${page + 1}
          </a>
        </li>
      `;
        })
        .join("")}
        ${
          !isLastPage
            ? `
              <li class="ais-Pagination-item ais-Pagination-item--page">
                <a
                  href="${createURL(currentRefinement + 1)}"
                  data-value="${currentRefinement + 1}"
                  rel="next"
                >
                  Next
                </a>
              </li>
              <li class="ais-Pagination-item ais-Pagination-item--page">
                <a
                  href="${createURL(nbPages - 1)}"
                  data-value="${nbPages - 1}"
                  rel="next"
                >
                  >
                </a>
              </li>
              `
            : ""
        }
    </ul>
  `;

  // on pagination change

  [...container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      console.log("paginate changed");
      document.querySelector("#paginate-trigger").scrollIntoView();
      refine(event.currentTarget.dataset.value);

      let promo_span = document
        .querySelector("#hits")
        .getAttribute("data-promo-span");

      const generatePromoCard = () => {
        let promo_img = document
          .querySelector("#hits")
          .getAttribute("data-promo-source");
        let promo_url = document
          .querySelector("#hits")
          .getAttribute("data-promo-url");
        let promo_span = document
          .querySelector("#hits")
          .getAttribute("data-promo-span");
        let promo_start = document
          .querySelector("#hits")
          .getAttribute("data-string-pos");

        let promo_title = document
          .querySelector("#hits")
          .getAttribute("data-promo-title");
        let promo_desc = document
          .querySelector("#hits")
          .getAttribute("data-promo-text");
        let promo_cta = document
          .querySelector("#hits")
          .getAttribute("data-promo-cta");

        let promo_t_colour = document
          .querySelector("#hits")
          .getAttribute("data-title-colour");
        let promo_colour = document
          .querySelector("#hits")
          .getAttribute("data-text-colour");

        let promo_colour_start = document
          .querySelector("#hits")
          .getAttribute("data-bg-colour-start");
        let promo_colour_end = document
          .querySelector("#hits")
          .getAttribute("data-bg-colour-end");

        return `
        <div id="promo-card-1" class="card-product promo-card card-carousel-js swiper-slide ${
          promo_span == "true" && "span-two"
        } start-pos-${promo_start}" data-handle="promo-only">
          <a style="background: linear-gradient(99deg,${promo_colour_start}, ${promo_colour_end});" class="card-product__wrapper-link" href="${promo_url}"></a>
            <div class="collection-breaker-inner">
              <h3 style="color: ${promo_t_colour}" class="breaker-title">${promo_title}</h3>
              <p style="color: ${promo_colour}" class="breaker-desc">${promo_desc}</p>
              <a href="${promo_url}"><button class="breaker-cta button button--primary button--primary--alternate">${promo_cta}</button></a>
            </div>
            <div class="card-product__imagewrap">
              <img src="${promo_img}" />
            </div>
          </div>
      `;
      };

      if (isPromoCard == "true") {
        setTimeout(() => {
          document.querySelector("#promo-card-1").style.display = "none";

          // grab all the current hits. then turn them to an array from a node list
          const els = document.querySelectorAll(".card-product");
          const all = Array.from(els);

          let promoData = {
            title: "Promo Card",
            updated_at: "2023-03-27T14:24:40.000Z",
            isPromo: "true",
            __position: parseInt(promoPos),
          };

          document
            .querySelector(`#${all[promoPos - 1].id}`)
            .parentElement.insertAdjacentHTML(
              "beforebegin",
              generatePromoCard(),
            );
          if (promo_span == "true") {
            document
              .querySelector(".promo-card")
              .parentElement.classList.add("span-two");
            document
              .querySelector(".promo-card")
              .parentElement.classList.add(`start-pos-`);
          }
        }, 100);
      }
    });
  });
};

// Create the custom widget
const customPagination = connectPagination(renderPagination);

// Instantiate the custom widget
collectionSearch.addWidgets([
  customPagination({
    container: document.querySelector("#pagination"),
    totalPages: 200,
  }),
]);

//  remove / block any empty facets from filters
collectionSearch.on("render", () => {
  document.querySelectorAll(".ais-RefinementList").forEach((f) => {
    let facetCount = f.querySelector(".ais-RefinementList-list");

    if (
      f.childElementCount == 0 ||
      (facetCount != null && facetCount.childElementCount == 1)
    ) {
      let parent = f.parentNode.previousElementSibling;
      parent.classList.add("blocked");
      parent.parentNode.classList.add("blocked");
    } else {
      let parent = f.parentNode.previousElementSibling;
      parent.classList.remove("blocked");
      parent.parentNode.classList.remove("blocked");
    }
  });

  const cards = document.querySelectorAll(".card-product");

  cards.forEach((item) => {
    const handle = item.dataset.handle;
    getShopifyProduct(item, handle);
    getReviewInfo(item, handle);
  });

  let promo_span = document
    .querySelector("#hits")
    .getAttribute("data-promo-span");
  let promo_start = document
    .querySelector("#hits")
    .getAttribute("data-string-pos");

  if (promo_span == "true") {
    document
      .querySelector(".promo-card")
      .parentElement.classList.add("span-two");
    document
      .querySelector(".promo-card")
      .parentElement.classList.add("promo-breaker");
    document
      .querySelector(".promo-card")
      .parentElement.classList.add(`start-pos-${promo_start}`);
  }

  const regeneratePromoCard = () => {
    let promo_img = document
      .querySelector("#hits")
      .getAttribute("data-promo-source");
    let promo_url = document
      .querySelector("#hits")
      .getAttribute("data-promo-url");
    let promo_span = document
      .querySelector("#hits")
      .getAttribute("data-promo-span");
    let promo_start = document
      .querySelector("#hits")
      .getAttribute("data-string-pos");

    let promo_title = document
      .querySelector("#hits")
      .getAttribute("data-promo-title");
    let promo_desc = document
      .querySelector("#hits")
      .getAttribute("data-promo-text");
    let promo_cta = document
      .querySelector("#hits")
      .getAttribute("data-promo-cta");

    let promo_t_colour = document
      .querySelector("#hits")
      .getAttribute("data-title-colour");
    let promo_colour = document
      .querySelector("#hits")
      .getAttribute("data-text-colour");

    let promo_colour_start = document
      .querySelector("#hits")
      .getAttribute("data-bg-colour-start");
    let promo_colour_end = document
      .querySelector("#hits")
      .getAttribute("data-bg-colour-end");

    return `
    <div id="promo-card-1" class="card-product promo-card card-carousel-js swiper-slide ${
      promo_span == "true" && "span-two"
    } start-pos-${promo_start}" data-handle="promo-only">
      <a style="background: linear-gradient(99deg,${promo_colour_start}, ${promo_colour_end});" class="card-product__wrapper-link" href="${promo_url}"></a>
        <div class="collection-breaker-inner">
          <h3 style="color: ${promo_t_colour}" class="breaker-title">${promo_title}</h3>
          <p style="color: ${promo_colour}" class="breaker-desc">${promo_desc}</p>
          <a href="${promo_url}"><button class="breaker-cta button button--primary button--primary--alternate">${promo_cta}</button></a>
        </div>
        <div class="card-product__imagewrap">
          <img src="${promo_img}" alt="promotion card" loading="lazy" />
        </div>
      </div>
  `;
  };

  // let refl = document.querySelector('#current-filters .ais-CurrentRefinements-list').innerHTML.length;

  // if(refl != 0){
  //   document.querySelector('.promo-breaker').style.display = "none";
  // } else {
  //   document.querySelector('.promo-breaker').style.display = "block";

  //   setTimeout(()=>{

  //     // grab all the current hits. then turn them to an array from a node list
  //     const els = document.querySelectorAll(".card-product");
  //     const all = Array.from(els);

  //     let promoData = {
  //       "title": "Promo Card",
  //       "updated_at": "2023-03-27T14:24:40.000Z",
  //       "isPromo": "true",
  //       "__position": parseInt(promoPos)
  //     }

  //     document.querySelector(`#${all[promoPos - 1].id}`).parentElement.insertAdjacentHTML('beforebegin', regeneratePromoCard())
  //     if(promo_span == "true" ){
  //       document.querySelector('.promo-card').parentElement.classList.add('span-two');
  //       document.querySelector('.promo-card').parentElement.classList.add(`start-pos-`);
  //     }

  //   },100)

  // }

  // console.log(cards);
});


collectionSearch.use(middleware);
collectionSearch.start();

// get template for reviews
async function getReviewInfo(card, handle) {

  if (handle == undefined || null) {
  } else {
    const shopifyProductUrl = `/products/${handle}?view=reviews`;

    try {
      const response = await fetch(shopifyProductUrl);
      const res = await response.text();

      let p = new DOMParser();
      let doc = p.parseFromString(res, "text/html");
      let template = doc.querySelector(".tp-stars-rating");

      const spacerTemplate = `<div class="tp-reviews-spacer"></div>`;

      const wrapper = card;
      const spacer = card.querySelector(".card-product__wrapper");

      wrapper.appendChild(template);
      spacer.appendChild(spacerTemplate);

    } catch (error) {
      console.error("Error:", error);
    }

  }
}


async function getShopifyProduct(card, handle) {
  if (handle == undefined || null) {
    return;
  } else {
    // Compose json url test
    const shopifyProductUrl = `/products/${handle}?view=quick-view`;

    try {
      const response = await fetch(shopifyProductUrl);
      const res = await response.text();

      let p = new DOMParser();
      let doc = p.parseFromString(res, "text/html");
      let template = doc.querySelector(".quick-view__container");
      let stocker = doc.querySelector(".card-product__oos");

      const insertion = card.querySelector(".card-product__imagewrap");

      const wrapper = card.querySelector(".card-product__wrapper");
      const hasColour = wrapper.querySelector(".card-product__colours img");

      if (!hasColour) {
        wrapper.appendChild(template);
      }

      if (stocker != null) {
        if (!card.querySelector(".card-product__oos")) {
          insertion.appendChild(stocker);
        }
        if (
          card.querySelector(".card-product__oos")?.innerHTML.length != 0 ||
          null
        ) {
          card.querySelector(".card-product__thumb ").classList.add("greyed");
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
}